import {MotorVariantList} from "./MotorVariantList";
import {MotorVariantEdit} from "./MotorVariantEdit";
import {MotorVariantCreate} from "./MotorVariantCreate";

export default {
    list: MotorVariantList,
    create: MotorVariantCreate,
    edit: MotorVariantEdit
};
